import { render, staticRenderFns } from "./import_excel_data.vue?vue&type=template&id=52bdb550&scoped=true"
import script from "./import_excel_data.vue?vue&type=script&lang=js"
export * from "./import_excel_data.vue?vue&type=script&lang=js"
import style0 from "./import_excel_data.vue?vue&type=style&index=0&id=52bdb550&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bdb550",
  null
  
)

export default component.exports